export default "__VITE_ASSET__BpDKj3Jh__"